import React from "react";
import { render } from "react-dom";
import { createBrowserHistory } from "history";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
//import "./index.css";
import 'styles/theme.scss';
import reportWebVitals from "./reportWebVitals";
import NotFoundScreen from "./views/NotFoundScreen";
import { ISADgCollection } from "./views/ISADgCollection";

const hist = createBrowserHistory();
render(
  <BrowserRouter history={hist}>
    <Routes>
      {/* <Route index path={process.env.PUBLIC_URL+'/'} element={<PrimaryScreen apiService={apiService} />} />
			<Route index path={process.env.PUBLIC_URL+'/collection/:isadg'} element={<ISADgCollection apiService={apiService}  />} /> */}
      <Route index path="/" element={<Navigate to="/search" />} />
      <Route index path="/search" element={<ISADgCollection />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  </BrowserRouter>,
  document.getElementById("c-root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
